import Button from "@material-ui/core/Button";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Zoom from "@material-ui/core/Zoom";
// material-ui
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import React from "react";
import { withCookies } from "react-cookie";
// styles
import styles from "./styles";

class TopMessage extends React.Component {
  static propTypes = {
    cookies: PropTypes.any,
    classes: PropTypes.object,
    icon: PropTypes.any,
    subtitle: PropTypes.any,
    body: PropTypes.any,
    action: PropTypes.any,
    cookie: PropTypes.object,
    position: PropTypes.string,
    background: PropTypes.string,
  };

  constructor(...args) {
    super(...args);
    const { cookie, cookies } = this.props;

    this.state = {
      confirmed: cookie ? cookies.get(cookie) : false,
    };
  }

  render() {
    const {
      classes,
      icon,
      subtitle,
      body,
      action,
      position,
      background,
      cookies,
      cookie,
    } = this.props;

    const { confirmed } = this.state;

    if (confirmed) {
      return <div />;
    }

    return (
      <ClickAwayListener onClickAway={() => this.setState({ confirmed: true })}>
        <Zoom in>
          <div
            style={{
              background,
              padding: 10,
              position: "absolute",
              bottom: position === "bottom" ? 0 : undefined,
              zIndex: 999,
              width: "calc(100vw - 20px)",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
            }}
          >
            <Grid
              container
              spacing={2}
              alignItems="center"
              justify="space-between"
            >
              <Grid item>
                <Grid container spacing={2} alignItems="center">
                  <Grid item>{icon}</Grid>
                  <Grid item>
                    <Typography
                      display="block"
                      variant="caption"
                      style={{
                        color: "white",
                      }}
                    >
                      {subtitle}
                    </Typography>
                    <Typography
                      display="block"
                      variant="body2"
                      style={{
                        color: "white",
                      }}
                    >
                      {body}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Button
                  size="small"
                  style={{
                    color: "#FFFFFF",
                    borderColor: "#FFFFFF",
                  }}
                  variant="outlined"
                  color="primary"
                  className={classes.button}
                  onClick={() => {
                    if (cookie) {
                      cookies.set(cookie, true, { path: "/" });
                    }

                    this.setState({ confirmed: true });
                  }}
                >
                  {action}
                </Button>
              </Grid>
            </Grid>
          </div>
        </Zoom>
      </ClickAwayListener>
    );
  }
}

export default withCookies(withStyles(styles)(TopMessage));
